import { strCol, numCol, intCol } from '@integec/grid-tools'
import { utilityHeader, unitIdHeader } from 'core/HeaderColTypeProps'

export const headers = [
  utilityHeader,
  unitIdHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
    width: 70,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isKey: true,
    width: 70,
  }),
  strCol({
    ident: 'revCode',
    display: 'Rev Code',
    width: 70,
  }),
  numCol({
    ident: 'netMaxCap',
    display: 'Net Maximum Capacity',
  }),
  numCol({
    ident: 'netDepCap',
    display: 'Net Dependable Capacity',
  }),
  numCol({
    ident: 'netActGen',
    display: 'Net Actual Generation',
  }),
  intCol({
    ident: 'loadChar',
    display: 'Load Characteristics',
  }),
  intCol({
    ident: 'attStart',
    display: 'Attempted Starts',
  }),
  intCol({
    ident: 'actualStart',
    display: 'Actual Satrt',
  }),
  intCol({
    ident: 'servHour',
    display: 'Service Hours',
  }),
  intCol({
    ident: 'resHour',
    display: 'Reserve Hours',
  }),
  intCol({
    ident: 'pumphour',
    display: 'Pump Hour',
  }),
  intCol({
    ident: 'syncHour',
    display: 'Synchronous Hours',
  }),
  intCol({
    ident: 'baseHour',
    display: 'Base Hours',
  }),
  intCol({
    ident: 'peakHour',
    display: 'Peak Hour',
  }),
  strCol({
    ident: 'line',
    display: 'Line',
  }),
  strCol({
    ident: 'lockReleased',
    display: 'Lock Released',
  }),
  intCol({
    ident: 'grossMaxCap',
    display: 'Gross Maximum Capacity',
  }),
  intCol({
    ident: 'grossDepCap',
    display: 'Gross Dependable Capacity',
  }),
  intCol({
    ident: 'grossActGen',
    display: 'Gross Actual Generation',
  }),

  strCol({
    ident: 'loadDesc',
    display: 'Load Description',
    desc: 200,
  }),
]

export const title = 'Card 95'

const readOnlyCols = ['utility', 'unit', 'year', 'month']

export const isEditable = ({ header }) => !readOnlyCols.includes(header.ident)
